import React, { Component } from 'react'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'

import { ArrowLeft, ArrowRight } from '../components/Icons'

const styles = theme => ({
  wrapperStyle: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  arrowButtonStyle: {
    minWidth: 40,
    width: 40,
    height: 40,
    backgroundColor: '#f0f1f2',
    color: '#e40045',
    borderRadius: 'inherit'
  },
  dotContainerStyle: {
    display: 'flex',
    width: 'calc(100% - 84px)',
    height: 40,
    backgroundColor: '#f0f1f2',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dotButtonStyle: {
    width: 12,
    height: 12,
    backgroundColor: '#e2e3e4',
    border: '1px solid #d6d8db',
    borderRadius: '50%',
    marginLeft: 5,
    marginRight: 5
  },
  dotButtonActiveStyle: {
    backgroundColor: '#e40045',
    border: '1px solid #e40045'
  }
})

class SliderControls extends Component {
  onDecreaseIndex = () => {
    const { onChangeIndex, activeIndex, mediaAmount } = this.props
    const newIndex = activeIndex - 1
    onChangeIndex(newIndex < 0 ? mediaAmount - 1 : newIndex)
  }

  onIncreaseIndex = () => {
    const { onChangeIndex, activeIndex, mediaAmount } = this.props
    const newIndex = activeIndex + 1
    onChangeIndex(newIndex === mediaAmount ? 0 : newIndex)
  }

  render() {
    const {
      activeIndex,
      mediaAmount,
      onChangeIndex,
      classes: {
        wrapperStyle,
        arrowButtonStyle,
        dotContainerStyle,
        dotButtonStyle,
        dotButtonActiveStyle
      }
    } = this.props

    return (
      <div className={`${wrapperStyle} slider-controls-wrapper`}>
        <IconButton
          classes={{ root: arrowButtonStyle }}
          onClick={this.onDecreaseIndex}
          disableRipple
        >
          <ArrowLeft size={16} />
        </IconButton>

        <div className={dotContainerStyle}>
          {[...Array(mediaAmount)].map((_, index) => (
            <div
              key={index}
              className={classNames(
                dotButtonStyle,
                index === activeIndex && dotButtonActiveStyle
              )}
              onClick={() => onChangeIndex(index)}
            />
          ))}
        </div>

        <IconButton
          classes={{ root: arrowButtonStyle }}
          onClick={this.onIncreaseIndex}
          disableRipple
        >
          <ArrowRight size={16} />
        </IconButton>
      </div>
    )
  }
}

export default withStyles(styles)(SliderControls)



// WEBPACK FOOTER //
// ./src/components/SliderControls.js